import fetchJSON from './fetch_json'
import fetchJs from './fetch_js'
import fetchGeneric from './fetch_generic'

const parseResponse = response => (response.json().then(data => ({
  data,
  status: response.status,
})));

const Fetchers = {
  fetchJSON,
  fetchJs,
  fetchGeneric,
  parseResponse,
}

export default Fetchers;
